<div class="grid-container margin-top margin-bottom-large wrapper">
  <form [formGroup]="form">
    <ng-container>

      <div class="cell small-12 medium-12 large-12">
        @if (form?.get('hasNoStimAdditives')?.value == true) {
          <div class="checkbox">
            <view-notes [fieldName]="'hasNoStimAdditives'" [notes]="getFilteredNotes('hasNoStimAdditives')" (notesRequested)="handleNotesRequested($event)"></view-notes>
            <input class="show-for-sr" id="hasNoStimAdditives" type="checkbox" formControlName="hasNoStimAdditives" />
            <label for="hasNoStimAdditives">
              No stimulation additives were used. Form 8B not applicable.
              <span class="checkbox-box"><span class="checkbox-check">&#x2714;</span></span>
            </label>
          </div>
        }
      </div>


      @if (form?.get('isInFracFocus')?.value == true) {
        <div class="checkbox">
          <view-notes [fieldName]="'isInFracFocus'" [notes]="getFilteredNotes('isInFracFocus')" (notesRequested)="handleNotesRequested($event)"></view-notes>
          <input class="show-for-sr" id="isInFracFocus" type="checkbox" formControlName="isInFracFocus" />
          <label for="isInFracFocus">
            Stimulation additives submitted to FracFocus.
            <span aria-hidden="true" class="checkbox-box"><span aria-hidden="true" class="checkbox-check">&#x2714;</span></span>
          </label>
        </div>
      }

      <div class="grid-x grid-margin-x padding-bottom-large section">
        <div class="cell small-12 medium-12 large-12 bold padding-left">
          Download Files:
        </div>
        <div class="cell small-12 medium-12 large-12 padding-left">
          <view-notes [fieldName]="'uploadedFiles'" [notes]="getFilteredNotes('uploadedFiles')" (notesRequested)="handleNotesRequested($event)"></view-notes>
          <upload-view-files [uniqueId]="'uploadedFiles'" [files]="storedFiles" [isPadded]="false" [componentLabel]="''" [showFileList]="true" [allowDeletion]="false" [allowUpload]="false">
          </upload-view-files>
        </div>
      </div>
      <hr />

      <label for="receivedDate">Form 8B Received Date</label>
      <view-notes [fieldName]="'receivedDate'" [notes]="getFilteredNotes('receivedDate')" (notesRequested)="handleNotesRequested($event)"></view-notes>
      <common-date-picker [id]="'receivedDate'" (dateUpdated)="onDateUpdated($event, 'receivedDate')" [initialDate]="receivedDate" [disabled]="form?.get('receivedDate')?.disabled"></common-date-picker>

      <label for="plugDate">Form 8B FracFocus Date</label>
      <view-notes [fieldName]="'fracFocusDate'" [notes]="getFilteredNotes('fracFocusDate')" (notesRequested)="handleNotesRequested($event)"></view-notes>
      <common-date-picker [id]="'fracFocusDate'" (dateUpdated)="onDateUpdated($event, 'fracFocusDate')" [initialDate]="fracFocusDate" [disabled]="form?.get('fracFocusDate')?.disabled"></common-date-picker>

      <label for="replugDate">Form 8B N/A Date</label>
      <view-notes [fieldName]="'nonAppDate'" [notes]="getFilteredNotes('nonAppDate')" (notesRequested)="handleNotesRequested($event)"></view-notes>
      <common-date-picker [id]="'nonAppDate'" (dateUpdated)="onDateUpdated($event, 'nonAppDate')" [initialDate]="nonAppDate" [disabled]="form?.get('nonAppDate')?.disabled"></common-date-picker>


      <div class="grid-x grid-margin-x">
        <div class="large-12 medium-12 small-12 text-align-center">
          @if (!isApproved && !isInCorrections) {
            <span class="minor-margin-right">
              <button class="button" (click)="onSave()">Save for Later</button>
            </span>
          }

          @if (!isApproved && !isInCorrections) {
            <span class="minor-margin-right">
              <button class="button" (click)="onAccept()">Accept</button>
            </span>
          }


          @if (!isApproved && !isInCorrections) {
            <span class="minor-margin-right">
              <button class="button" (click)="onReturn()">Return For Corrections</button>
            </span>
          }

          <span>
            <button class="button" (click)="cancel()">Cancel</button>
          </span>
        </div>


      </div>
    </ng-container>



  </form>
</div>
